export const GetCetificatesAndAgency=()=>{
 return $.get('Certification/GetAgencyCertificateNameTree?IsActive=IsActive')
}
export const AddCertificate=(certificate)=>{//alert ("ADD CERT SINGULAR")
   var x = $.ajax({
        url: 'Certification/AddPersonnelCertification',
        data: certificate,
        processData: false,
        contentType: false,
        'accept-charset': 'utf-8',
        cache: false,
        type: 'POST'
      })
      //alert("ADDING: " + JSON.stringify(x))
    return x;
}
export const DeleteCertificateList=(id)=>{
    var x = $.post('Certification/DeletePersonnelCertification?Id='+id)
    return x
}
export const UpdateCertificate=(certificate)=>{//alert("UPDATE CERT SINGULAR")

    var x = $.ajax({
        url: 'Certification/UpdatePersonnelCertification', //FG - FIND THIS ON SERVER
        data: certificate,
        processData: false,
        contentType: false,
        'accept-charset': 'utf-8',
        cache: false,        
        type: 'POST'
      })
      //.done(function(){alert ("LOOK HERE PROBABLY DON'T NEED .done .fail .always if you use createHydrowareRestrictedResult on the server")})
      //.fail(function(z){
      //    alert("failed:"+JSON.stringify(z))})
      //.always(function(v){
      //    alert("always"+JSON.stringify(v))})

      //alert("IN addcertificates.service.js UpdateCertificate: " + JSON.stringify(x))
      return x;
}
export const GetCertificateList=(id)=>{
    return $.get('Certification/GetPersonnelCertifications?PersonnelId='+id+'&IsActive='+null)
}

export const ChangeStatus=(id,IsActive)=>{
    return $.post('Certification/ChangePersonnelCertificationStatus?Id='+id+'&activeStatus='+IsActive)
}
export const AllCertificates=(value,id)=>{
    return $.get('Certification/GetAllCertificateName?IsActive='+value+'&organizationId='+id)
}
export const AddCertificates=(certificate)=>{
    return $.post('Certification/AddCertificateByNameNAgency',certificate)
}
export const GetCertifictaeTopics=(IsActive)=>{
    return $.get('Certification/GetAllCertificateName_New?IsActive='+IsActive+'&organizationId=0')
}
// export const DeleteCertificate=(id)=>{
//     return $.post('Certification/DeleteCertificate?Id='+id)
// }
export const UpdateCertificates=(certificate)=>{
    return $.post('Certification/UpdateCertificate',certificate)
}
export const GetCertificateAgencyTree=(id,status)=>
{
    /*******************************************************************************************
    FG - FOOF - After Cert - First Release - this had been returning only active agencies for
    a certificate making it impossible to "re-activate" that agency.  I changed this so it
    returns ALL of the agencies regardless of the active status.
       return $.get('Certification/GetCertificateNameAgencyTree?IsActive='+true+'&organizationId='+id)
    ********************************************************************************************/
    return $.get('Certification/GetCertificateNameAgencyTree?IsActive='+null+'&organizationId='+id)
}

    /*
    admin cert - DEACTIVATE - IS NO LONGER USED - THE STATUS CHANGE TAKES PLACE WHEN THE "row" IS SAVED
    //NOT WHEN THE CHECKBOX IS CHECKED FIND "FOOF - CERTIFICATE - ACTIVATE/DEACTIVATE" IN OTHER FILES
    //FOR MORE DETAILS
    export const ChangeCertificateStatus=(object,id )=>{            
            alert("addcertificates.service.js - ChangeCertificationStatus(object,id) - Tell developer if you see this message")
            return $.post('Certification/ChangeCertificateStatusList?organizationId='+id,object)
    }
    */
    export const GetAllCertificateAgency=(id)=>
    {
        return $.get('Certification/GetAllCertificateAgency?IsActive=null&organizationId='+id)
    }
    export const DeleteCertificate=(idlist,id)=>{alert("DELETE ??????")
        return $.post('Certification/DeleteCertificateList?organizationId='+id,idlist)
    }
    export const EditCertificateTopic=(certificate)=>{
       return $.post('Certification/UpdateCertificateName',certificate)
    }
    export const AddCertificateName=(certificatetopic,id)=>{
        //admin cert - Goes with CREATE CERTIFICATE NAME        
        var jqxhr = $.post('Certification/AddCertificateName?organizationId='+id,certificatetopic);
        return jqxhr;
    }
    //FG - FOOF - After Cert - First Release - I DON'T THINK THE FUNCTION BELOW IS EVER CALLED
    export const AddAgencies=(status,id)=>{
        return $.get('Certification/GetAllCertificateByNameId?IsActive='+status+'&CertificateNameId='+id)
    }


// WEBPACK FOOTER //
// ./src/components/Certificates/addcertificates.service.js